const hasLineItemTypes = (lineItems, producTypes)=>{
    return lineItems.some((item)=>{
        return producTypes === null || producTypes === void 0 ? void 0 : producTypes.includes(item.type);
    });
};

export { hasLineItemTypes };
//# sourceMappingURL=has-line-item-types.js.map
